import SimpleReactValidator from "simple-react-validator";
import React, { useState, useRef, useEffect } from "react";
import InputField from "@_common/InputRuleFeild";
import { getValue, setValue } from "@utils/lodash";
import {
	adminGetCitiesListManagement,
	adminGetCountriesListManagement,
	adminGetListManagementGroupCode,
	adminGetStatesListManagement,
} from "@services/list-management.service";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
	clientCreateVendor,
	clientGetSpecificVendor,
	clientUpdateSpecificVendor,
} from "@services/vendors.service";
import countries from "@_common/contry.json";
import Loader from "@components/common/Loader";
import { Col, Input } from "reactstrap";
import { vendorFileUpload } from "@services/checkpoint.service";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import "./vendor-profile.scss";
import _ from "lodash";
import { useCallbackPrompt } from "@prompt/useCallbackPrompt";
import PromptModal from "@prompt/modal";
import { handleDownloadOnClick } from "@_common/downloadfile";

interface IVendorDetailInfoProfileProps {}

const VendorDetailInfoProfile: React.FunctionComponent<
	IVendorDetailInfoProfileProps
> = (props) => {
	let navigate = useNavigate();
	let params = useParams();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const [isLoading, setIsLoading] = useState(false);
	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);
	const [request, setRequest] = React.useState<any>({
		vendor_code: "",
		vendor_name: "",
		vendor_type: "SERVICING_VENDOR",
		parent_id: "",
		industry: "",
		business_type: "",
		// region: "",
		address1: "",
		address2: "",
		country_id: "101",
		state_id: "",
		city_id: "",
		pincode: "",
		country_code_phone1: "",
		phone1: "",
		country_code_phone2: "",
		phone2: "",
		email1: "",
		is_poc_email1: true,
		email2: "",
		is_poc_email2: false,
		is_msme: true,
		agreement_expiry_date: "",
		msme_certificate: "",
		agreement_doc: "",
		gstin_no: "",
	});
	const [dirtyFields, setDirtyFields] = useState<any>({
		vendor_code: "",
		vendor_name: "",
		vendor_type: "SERVICING_VENDOR",
		parent_id: "",
		industry: "",
		business_type: "",
		// region: "",
		address1: "",
		address2: "",
		country_id: "101",
		state_id: "",
		city_id: "",
		pincode: "",
		country_code_phone1: "",
		phone1: "",
		country_code_phone2: "",
		phone2: "",
		email1: "",
		is_poc_email1: true,
		email2: "",
		is_poc_email2: false,
		is_msme: true,
		agreement_expiry_date: "",
		msme_certificate: "",
		agreement_doc: "",
		gstin_no: "",
	});
	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);
	const [citiesList, setCityList] = useState([]);

	const [industryTypeList, setIndustryTypeList] = useState([]);
	const [businessTypeList, setBusinessTypeList] = useState([]);
	const [regionTypeList, setRegionTypeList] = useState([]);
	const [vendorTypeList] = useState([
		{ value: "PRIME_VENDOR", label: "PRIME_VENDOR" },
		{ value: "SERVICING_VENDOR", label: "SERVICING_VENDOR" },
	]);

	const [loading, setLoading] = useState(false);
	const [mobile_code1, setMobile_code1] = useState<any>("");
	const [mobile_code2, setMobile_code2] = useState<any>("");
	const [parentId, setParentId] = useState("");
	const [vendor_id, setVendor_id] = useState("");

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		getIndustryList();
		getBusinessTypeList();
		getRegionList();
		getCountriesList();

		let user = JSON.parse(getValue(localStorage, `user`, {}));
		let vendor_id = getValue(user, `vendor.id`, "");
		if (vendor_id) {
			getData(vendor_id);
			setVendor_id(vendor_id);
		}
	}, []);

	useEffect(() => {
		getStatesList(request.country_id);
		if (request.state_id) {
			getCitiesList(request.state_id);
		}
	}, [request.country_id, request.state_id]);
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const [dashboardInfo, setDashboardInfo] = useState({});
	const getData = async (id: string) => {
		try {
			setLoading(true);
			let resp = await clientGetSpecificVendor(id);
			if (resp) {
				console.log(resp)
				setDashboardInfo(resp);
				setLoading(false);
				let countryCode1 = countries.filter(
					(item: object) =>
						getValue(item, `dial_code`, "") ===
						getValue(resp, `data.country_code_phone1`, "")
				);
				let countryCode2 = countries.filter(
					(item: object) =>
						getValue(item, `dial_code`, "") ===
						getValue(resp, `data.country_code_phone2`, "")
				);
				// mobile_area_code
				let code1: any =
					countryCode1.length > 0 &&
					countryCode1.map((item) => ({
						id: getValue(item, `id`, ""),
						country: item.code,
						label: <>{item.dial_code + " " + item.name}</>,
						value: item.dial_code + " " + item.name,
					}));

				let code2: any =
					countryCode2.length > 0 &&
					countryCode2.map((item) => ({
						id: getValue(item, `id`, ""),
						country: item.code,
						label: <>{item.dial_code + " " + item.name}</>,
						value: item.dial_code + " " + item.name,
					}));
				setParentId(getValue(resp, `data.parent_id`, ""));
				setRequest({
					...request,
					country_id: getValue(resp, `data.country.id`, ""),
					state_id: getValue(resp, `data.state.id`, ""),
					city_id: getValue(resp, `data.city.id`, ""),
					address1: getValue(resp, `data.address1`, ""),
					address2: getValue(resp, `data.address2`, ""),
					// entity_name: getValue(resp, `data.entity_name`, ""),
					vendor_code: getValue(resp, `data.vendor_code`, ""),
					pincode: getValue(resp, `data.pincode`, ""),
					vendor_name: getValue(resp, `data.vendor_name`, ""),
					vendor_type: getValue(resp, `vendor_type`, ""),
					location_id: getValue(resp, `data.location_id`, ""),
					industry: getValue(resp, `data.industry.id`, ""),
					business_type: getValue(resp, `data.business_type.id`, ""),
					// region: getValue(resp, `data.region.id`, ''),
					phone1: getValue(resp, `data.phone1`, ""),
					phone2: getValue(resp, `data.phone2`, ""),
					email1: getValue(resp, `data.email1`, ""),
					email2: getValue(resp, `data.email2`, ""),
					is_poc_email1: getValue(resp, `data.is_poc_email1`, ""),
					is_poc_email2: getValue(resp, `data.is_poc_email2`, ""),
					country_code_phone1: getValue(resp, `data.country_code_phone1`, ""),
					country_code_phone2: getValue(resp, `data.country_code_phone2`, ""),
					agreement_doc: getValue(resp, `data.agreement_doc`, ""),
					msme_certificate: getValue(resp, `data.msme_certificate`, ""),
					agreement_expiry_date: getValue(
						resp,
						`data.agreement_expiry_date`,
						""
					),
					is_msme: getValue(resp, `data.is_msme`, false),
					gstin_no: getValue(resp, `data.gstin_no`, null),
				});
				setDirtyFields({
					...dirtyFields,
					country_id: getValue(resp, `data.country.id`, ""),
					state_id: getValue(resp, `data.state.id`, ""),
					city_id: getValue(resp, `data.city.id`, ""),
					address1: getValue(resp, `data.address1`, ""),
					address2: getValue(resp, `data.address2`, ""),
					// entity_name: getValue(resp, `data.entity_name`, ""),
					vendor_code: getValue(resp, `data.vendor_code`, ""),
					pincode: getValue(resp, `data.pincode`, ""),
					vendor_name: getValue(resp, `data.vendor_name`, ""),
					vendor_type: getValue(resp, `vendor_type`, ""),
					location_id: getValue(resp, `data.location_id`, ""),
					industry: getValue(resp, `data.industry.id`, ""),
					business_type: getValue(resp, `data.business_type.id`, ""),
					// region: getValue(resp, `data.region.id`, ''),
					phone1: getValue(resp, `data.phone1`, ""),
					phone2: getValue(resp, `data.phone2`, ""),
					email1: getValue(resp, `data.email1`, ""),
					email2: getValue(resp, `data.email2`, ""),
					is_poc_email1: getValue(resp, `data.is_poc_email1`, ""),
					is_poc_email2: getValue(resp, `data.is_poc_email2`, ""),
					country_code_phone1: getValue(resp, `data.country_code_phone1`, ""),
					country_code_phone2: getValue(resp, `data.country_code_phone2`, ""),
					agreement_doc: getValue(resp, `data.agreement_doc`, ""),
					msme_certificate: getValue(resp, `data.msme_certificate`, ""),
					agreement_expiry_date: getValue(
						resp,
						`data.agreement_expiry_date`,
						""
					),
					is_msme: getValue(resp, `data.is_msme`, false),
					gstin_no: getValue(resp, `data.gstin_no`, null),
				});
				setMobile_code1(
					getValue(code1, `length`, 0) > 0 ? getValue(code1, `[${0}]`, "") : ""
				);
				setMobile_code2(
					getValue(code2, `length`, 0) > 0 ? getValue(code2, `[${0}]`, "") : ""
				);

				if (getValue(resp, `data.country.id`, "")) {
					getStatesList(getValue(resp, `data.country.id`, ""));
				}
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
		}
	};

	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getStatesList = async (countryId: number) => {
		try {
			let resp = await adminGetStatesListManagement(countryId);
			if (resp) {
				setStates(
					getValue(resp, `data.states`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getIndustryList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("industry");
			if (resp) {
				setIndustryTypeList(
					getValue(resp, `data.listItems`, []).map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getCitiesList = async (stateId: number) => {
		try {
			let resp = await adminGetCitiesListManagement(stateId);
			if (resp) {
				setCityList(
					getValue(resp, `data.cities`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getRegionList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("region-type");
			if (resp) {
				setRegionTypeList(
					getValue(resp, `data.listItems`, []).map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getBusinessTypeList = async () => {
		try {
			let resp = await adminGetListManagementGroupCode("business-type");
			if (resp) {
				setBusinessTypeList(
					getValue(resp, `data.listItems`, []).map((item: object) => ({
						id: getValue(item, `id`, ""),
						is_active: getValue(item, `is_active`, ""),
						text: getValue(item, `text`, ""),
						value: getValue(item, `text`, ""),
						label: getValue(item, `text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			let payload = JSON.parse(JSON.stringify(request));
			payload.agreement_doc = getValue(payload, `agreement_doc.id`, "");
			payload.msme_certificate = getValue(payload, `msme_certificate.id`, "");
			// payload.gstin_no = getValue(payload, `gstin_no`, null);
			payload.pincode = parseInt(payload.pincode);
			payload.parent_id = parentId;
			payload.country_id = parseInt(payload.country_id);
			payload.state_id = parseInt(payload.state_id);
			payload.city_id = parseInt(payload.city_id);
			payload.country_code_phone1 = getValue(mobile_code1, `value`, "").split(
				" "
			)[0];
			payload.country_code_phone2 = getValue(mobile_code2, `value`, "").split(
				" "
			)[0];
			Object.keys(payload).forEach((key) => {
				if (payload[key] == "" || payload[key] === undefined || !payload[key]) {
					delete payload[key];
				}
			});
			// if (getValue(params, `id`, '')) {
			try {
				setIsLoading(true);
				payload.vendor_type = request.vendor_type
					? request.vendor_type
					: "SERVICING_VENDOR";
				let resp = await clientUpdateSpecificVendor(vendor_id, payload);
				if (resp) {
					confirmNavigation();
					setIsLoading(false);
					toast.success(getValue(resp, "message", ""));
					// navigate(`/vendors/detail/${params.parentId}`);
				} else {
					setIsLoading(false);
				}
			} catch (error) {
				setIsLoading(false);
			}
			// } else {
			// 	payload.vendor_type = 'SERVICING_VENDOR';
			// 	try {
			// 		setIsLoading(true);
			// 		let resp = await clientCreateVendor(payload);
			// 		if (resp) {
			// 			setIsLoading(false);
			// 			toast.success(getValue(resp, 'message', ''));
			// 			navigate(`/vendors/detail/${params.parentId}`);
			// 		} else {
			// 			setIsLoading(false);
			// 		}
			// 	} catch (error) {
			// 		setIsLoading(false);
			// 	}
			// }
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeSelect = (e: any, type: string) => {
		if (type === "country_id") {
			getStatesList(e.id);
			setRequest({
				...request,
				country_id: e.id,
			});
		}
		if (type === "state_id") {
			getCitiesList(e.id);
			setRequest({
				...request,
				state_id: e.id,
			});
		}
		if (type === "industry") {
			setRequest({
				...request,
				industry: e.id,
			});
		}
		if (type === "business_type") {
			setRequest({
				...request,
				business_type: e.id,
			});
		}
		if (type === "city_id") {
			setRequest({
				...request,
				city_id: e.id,
			});
		}
		if (type === "region") {
			setRequest({
				...request,
				region: e.id,
			});
		}
		if (type === "vendor_type") {
			setRequest({
				...request,
				vendor_type: e.value,
			});
		}
	};

	const handleChangeText = (e: any) => {
		const { name, value } = e.target;
		setRequest({
			...request,
			[name]: value,
		});
	};

	const onChange = (value: string) => {
		setRequest({
			...request,
			[value]: !request[value],
		});
	};

	const handleChangeFile = async (e: any, name: string) => {
		let formData = new FormData();
		formData.append("file", e.target.files[0]);
		try {
			let resp = await vendorFileUpload(formData);
			if (resp) {
				if (name === "msme_certificate") {
					setRequest({
						...request,
						msme_certificate: getValue(resp, `data`, ""),
					});
				} else {
					setRequest({ ...request, agreement_doc: getValue(resp, `data`, "") });
				}
				e.target.value = null;
			}
		} catch (error) {}
	};
	/* -------------------------------------------------------------------------- */
	/*                                Prompt Section                              */
	/* -------------------------------------------------------------------------- */
	const [isChanged, setIsChanged] = useState(false);
	useEffect(() => {
		setIsChanged(
			_.isEqualWith(request, dirtyFields, (a: any, b: any) => {
				// if both are null or equal to an empty string then they are equal
				if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
			})
		);
	});
	const [showPrompt, confirmNavigation, cancelNavigation]: any =
		useCallbackPrompt(!isChanged);
	return (
		<DashboardLayout>
			<PromptModal
				showDialog={showPrompt}
				confirmNavigation={confirmNavigation}
				cancelNavigation={cancelNavigation}
			/>
			{loading ? (
				<Loader />
			) : (
				<div>
					<div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
						<h4 className="dashbaord-wrapper__header-title">
							Vendor Org Profile
						</h4>
					</div>
					<div className="sub-header d-flex align-items-center justify-content-between">
						{getValue(
							dashboardInfo,
							`data.agreement_expiry_info.isError`,
							""
						) ||
						getValue(
							dashboardInfo,
							`data.agreement_expiry_info.is_expired`,
							""
						) ? (
							<div className="checkpoints-timer-wrapper-error m-2 d-flex align-items-center">
								<img src="/images/red-awesome.svg" className="img-fluid" />
								<p className="mx-2">
									{getValue(
										dashboardInfo,
										`data.agreement_expiry_info.msg`,
										""
									)}
								</p>
							</div>
						) : (
							<div className="checkpoints-timer-wrapper m-2 d-flex align-items-center">
								<img src="/images/purple-awesome.svg" className="img-fluid" />
								<p className="mx-2">
									{getValue(
										dashboardInfo,
										`data.agreement_expiry_info.days`,
										""
									)}{" "}
									{getValue(
										dashboardInfo,
										`data.agreement_expiry_info.msg`,
										""
									)}
								</p>
							</div>
						)}
					</div>
					<div className="vendor-profile-form-wrapper">
						<div className="vendor-profile-wrapper">
							<div className="vendor-profile-wrapper__form-group form-group mb-0">
								<label className="vendor-profile-wrapper__label">
									Vendor Organization Name <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Location Name"
									className="vendor-profile__form-control"
									name="vendor_name"
									id="vendor_name"
									value={getValue(request, `vendor_name`, "")}
									onChange={(e: any) => handleChangeText(e)}
									label="Vendor Name"
									validator={simpleValidator}
									disabled
								/>
							</div>
						</div>
						<div className="vendor-profile-wrapper">
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Vendor Code <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Vendor Code"
									className="vendor-profile__form-control form-control"
									name="vendor_code"
									id="vendor_code"
									value={getValue(request, `vendor_code`, "")}
									onChange={(e: any) => handleChangeText(e)}
									label="Vendor Code"
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									GSTIN Number <span></span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter GSTIN Number"
									className="vendor-profile__form-control form-control"
									name="gstin_no"
									id="gstin_no"
									value={getValue(request, `gstin_no`, "")}
									onChange={(e: any) => handleChangeText(e)}
									label="GSTIN Number"
									// validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Industry <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Enter Industry"
									className="vendor-profile__form-control form-control"
									name="industry"
									id="industry"
									options={industryTypeList}
									value={industryTypeList.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `industry`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "industry")}
									label="Industry"
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group">
								<label className="vendor-profile-wrapper__label">
									Business Type <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Enter Business Type"
									className="vendor-profile__form-control form-control"
									name="business_type"
									id="business_type"
									options={businessTypeList}
									value={businessTypeList.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `business_type`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "business_type")}
									label="Business Type"
									validator={simpleValidator}
									disabled
								/>
							</div>
						</div>
						<div>
							<div className="vendor-profile-wrapper__form-group form-group">
								<label className="vendor-profile-wrapper__label">
									Company Address (Line 1)<span>*</span>
								</label>
								<InputField
									inputType="TEXTAREA"
									placeholder="Enter Company Address (Line 1)"
									className="vendor-profile__form-control"
									name="address1"
									id="address1"
									label="Address Line1"
									value={getValue(request, `address1`, "")}
									onChange={(e: any) => handleChangeText(e)}
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group">
								<label className="vendor-profile-wrapper__label">
									Company Address (Line 2)<span></span>
								</label>
								<InputField
									inputType="TEXTAREA"
									placeholder="Enter Company Address (Line 2)"
									className="vendor-profile__form-control"
									name="address2"
									id="address2"
									label="Address Line2"
									value={getValue(request, `address2`, "")}
									onChange={(e: any) => handleChangeText(e)}
									// validator={simpleValidator}
									disabled
								/>
							</div>
						</div>
						<div className="vendor-profile-wrapper">
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Country <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose Country"
									className="vendor-profile__form-control"
									name="country_id"
									id="country_id"
									options={countryList}
									value={countryList.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `country_id`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "country_id")}
									label="Country"
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									State <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose State"
									className="vendor-profile__form-control"
									name="state_id"
									id="state_id"
									label="Last Name"
									options={states}
									value={states.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `state_id`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "state_id")}
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									City <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose State"
									className="vendor-profile__form-control"
									name="city_id"
									id="city_id"
									label="City"
									options={citiesList}
									value={citiesList.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `city_id`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "city_id")}
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Pincode <span>*</span>
								</label>
								<InputField
									inputType="TEXT"
									placeholder="Enter Pincode"
									className="vendor-profile__form-control"
									name="pincode"
									id="pincode"
									value={getValue(request, `pincode`, "")}
									onChange={(e: any) => handleChangeText(e)}
									label="Pincode"
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Area Code <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT_COUNTYCODE"
									placeholder="Enter Area Code"
									className="vendor-profile__form-control"
									name="mobile_area_code"
									id="mobile_area_code"
									label="Mobile Area Code"
									value={mobile_code1}
									onChange={(e: any) => setMobile_code1(e)}
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Primary Mobile Number <span>*</span>
								</label>
								<InputField
									inputType="PHONE"
									placeholder="Enter Phone Number 1"
									className="vendor-profile__form-control"
									name="phone1"
									id="phone1"
									label="Mobile Number"
									value={getValue(request, `phone1`, "")}
									onChange={(e: any) => handleChangeText(e)}
									validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Area Code
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT_COUNTYCODE"
									placeholder="Enter Area Code"
									className="vendor-profile__form-control"
									name="mobile_area_code"
									id="mobile_area_code"
									label="Mobile Area Code"
									value={mobile_code2}
									onChange={(e: any) => setMobile_code2(e)}
									// validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									Alternative Mobile Number
								</label>
								<InputField
									inputType="PHONE"
									placeholder="Enter Phone Number 1"
									className="vendor-profile__form-control"
									name="phone2"
									id="phone2"
									label="Mobile Number"
									value={getValue(request, `phone2`, "")}
									onChange={(e: any) => handleChangeText(e)}
									// validator={simpleValidator}
									disabled
								/>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									POC Email Address 1 <span>*</span>
								</label>
								<div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
									<div className="position-relative">
										<InputField
											inputType="TEXT"
											placeholder="Enter Primary Email"
											clclassName="vendor-profile__form-control "
											name="email1"
											id="email1"
											value={getValue(request, `email1`, "")}
											onChange={(e: any) => handleChangeText(e)}
											label="Email"
											validator={simpleValidator}
											disabled
										/>
										<div className="vendor-profile-switch custom-switch-wrapper">
											<label className="switch">
												<input
													type="checkbox"
													checked={getValue(request, `is_poc_email1`, false)}
													onChange={() => onChange("is_poc_email1")}
													className="m-0"
												/>
												<span className="slider round"></span>
											</label>
										</div>
									</div>
								</div>
							</div>
							<div className="vendor-profile-wrapper__form-group form-group m-0">
								<label className="vendor-profile-wrapper__label">
									POC Email Address 2
								</label>
								<div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
									<div className="position-relative">
										<InputField
											inputType="TEXT"
											placeholder="Enter Primary Email"
											className="vendor-profile__form-control"
											name="email2"
											id="email2"
											value={getValue(request, `email2`, "")}
											onChange={(e: any) => handleChangeText(e)}
											label="email2"
											disabled
										/>
										<div className="vendor-profile-switch custom-switch-wrapper">
											<label className="switch">
												<input
													type="checkbox"
													checked={getValue(request, `is_poc_email2`, false)}
													onChange={() => onChange("is_poc_email2")}
												/>
												<span className="slider round"></span>
											</label>
										</div>
									</div>
								</div>
							</div>
							<div className="user-details-wrapper__form-group form-group">
								<label className="vendor-profile-wrapper__label">
									Are you an MSME?
								</label>

								<div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center mt-3">
									<input
										type="radio"
										checked={getValue(request, `is_msme`, false)}
										onChange={() => setRequest({ ...request, is_msme: true })}
										disabled
									/>
									<label className="mr-3">Yes</label>
								</div>
								<div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center mt-3">
									<input
										type="radio"
										checked={!getValue(request, `is_msme`, false)}
										onChange={() => setRequest({ ...request, is_msme: false })}
										disabled
									/>
									<label className="mr-3">No</label>
								</div>
							</div>
						</div>
						<div className="user-details-wrapper__form-group form-group d-flex">
							<label className="vendor-profile-wrapper__label vendor-profile-wrapper__label--upload d-flex">
								Upload MSME Registration Certificate <span>-------</span>
								<input
									type={"file"}
									onChange={(e) => handleChangeFile(e, "msme_certificate")}
									className="d-none"
								/>
								<p className="cursor-pointer upload-files">Upload Files</p>
							</label>
						</div>
						{getValue(request, `msme_certificate.id`, "") && (
							<div className="msme-certificate cursor-pointer">
								<div className="d-flex justify-content-between align-items-center cursor-pointer"
								onClick={() =>
									handleDownloadOnClick(
										getValue(request, `msme_certificate.url`, ""),
										getValue(request, `msme_certificate.name`, "")
									)
								}
								>
									<p>{getValue(request, `msme_certificate.name`, "")}</p>
									<p
										style={{ color: "red" }}
										onClick={() =>
											setRequest({ ...request, msme_certificate: "" })
										}
									>
										<img
											src="/images/close-black.svg"
											className="img-fluid cursor-pointer"
										/>
									</p>
								</div>
							</div>
						)}
						<Col>
							<div className="vendor-profile-wrapper__form-group form-group my-3">
								<label className="vendor-profile-wrapper__label">
									Vendor Agreement Expiration Date
								</label>
								<InputField
									inputType="DATETYPE-DOB"
									value={
										getValue(request, `agreement_expiry_date`, "")
											? new Date(getValue(request, `agreement_expiry_date`, ""))
											: null
									}
									onChange={(e: any) =>
										setRequest({
											...request,
											// agreement_expiry_date: moment(e).format('YYYY-MM-DD'),
											agreement_expiry_date: e,
										})
									}
									minDate={new Date()}
									placeholderText="Enter Expiration Date"
								/>

								{/* <Input
									type="date"
									value={getValue(request, `agreement_expiry_date`, '')}
									onChange={(e) =>
										setRequest({
											...request,
											agreement_expiry_date: e.target.value,
										})
									}
									minDate={new Date()}
								/> */}
							</div>
						</Col>
						<div className="vendor-profile-wrapper__form-group form-group m-0 d-flex">
							<label className="vendor-profile-wrapper__label d-flex">
								Vendor Agreement Copy<span>-------</span>
								<input
									type={"file"}
									onChange={(e) => handleChangeFile(e, "agreement_doc")}
									className="d-none"
								/>
								<p className="cursor-pointer upload-files">Upload Files</p>
							</label>
						</div>
						{getValue(request, `agreement_doc.id`, "") && (
							<div className="msme-certificate my-3 cursor-pointer">
								<div
									className="d-flex  justify-content-between align-items-center"
									onClick={() =>
										handleDownloadOnClick(
											getValue(request, `agreement_doc.url`, ""),
											getValue(request, `agreement_doc.name`, "")
										)
									}
								>
									<p>{getValue(request, `agreement_doc.name`, "")}</p>
									<p
										style={{ color: "red" }}
										onClick={() =>
											setRequest({ ...request, agreement_doc: "" })
										}
									>
										<img
											src="/images/close-black.svg"
											className="img-fluid cursor-pointer"
										/>
									</p>
								</div>
							</div>
						)}
						<div className="user-details-wrapper__cta-btns mt-3">
							{/* <NavLink to={`/checkpoint/active`}>
								<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
									Cancel
								</button>
							</NavLink> */}
							{isLoading ? (
								<button className="ascent-button  ascent-button--header-buttons ascent-button--secondary">
									Please wait...
								</button>
							) : (
								<button
									className={`ascent-button ascent-button--header-buttons ascent-button--${
										isChanged ? "primary" : "secondary"
									}`}
									onClick={handleSubmit}
									disabled={isChanged}
								>
									{getValue(params, `id`, "") ? "Update" : "Submit"}
								</button>
							)}
						</div>
					</div>
					<div className="footer-image w-100 mx-3">
						<img src="/images/profile-illustration.svg" className="img-fluid" />
					</div>
				</div>
			)}
		</DashboardLayout>
	);
};

export default VendorDetailInfoProfile;
